<template>
<!-- 商家渠道 -->
<section class="viewContainer">
  <!-- 选择栏 -->
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="商家渠道" name="first"/>
    <el-tab-pane label="被邀渠道" name="second"/>
  </el-tabs>
  <!-- 商家渠道 -->
  <div class="main_container" v-show="activeName=='first'">
    <!-- 我的联盟--管理联盟--列表 -->
    <div v-if="statusMA==3">
      <!-- 顶部搜索框 -->
      <el-form :inline="true" :model="filters" class="findform">
        <el-form-item style="display:flex;width:50%">
          <el-input v-model="filters.EnterpriseName" placeholder="搜索店铺名称" maxlength="20" style="width:90%"/>
        </el-form-item>
        <el-form-item style="width:100%">
          <el-button type="danger" @click="onSubmit">查询</el-button>
          <el-button type="danger" @click="inviteMerchants">邀请渠道</el-button>
        </el-form-item>
      </el-form>
      <div class="table_container">
        <el-table :data="fourMAList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="渠道名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.channelname">{{scope.row.channelname}}</span>
            </template>
          </el-table-column>
          <el-table-column label="负责人" align="center">
            <template scope="scope">{{scope.row.linkman}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.linkphone}}</template>
          </el-table-column>
          <el-table-column label="渠道类型" align="center">
            <template scope="scope">{{scope.row.channeltypename}}</template>
          </el-table-column>
          <el-table-column label="邀请时间" align="center">
            <template scope="scope">{{scope.row.invitetime}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.statusname}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template scope="scope">
              <span @click="seeYaoqing(scope.row,5)" class="handle"> 查看 </span>
              <span @click="fourMATipsFun(scope.row,2)" class="handle" v-if="scope.row.status==1 && scope.row.issendnotice==0"> 通知渠道 </span>
              <span @click="agreeRefuse(scope.row,4)" class="handle" v-if="scope.row.status==2"> 移除渠道 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabFour"
        :current-page="pageIndexFour" :page-size="10" :total="totalRowsCountFour" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <!-- 邀请商家 -->
    <div class="displayFlex" v-if="statusMA==4">
      <el-card class="box-card card1" :style="'height:'+scrollbarHeight">
        <el-tree :data="oneData" ref="rightsTree" :props="defaultProps" class="lineheighttree"
        node-key="id" highlight-current @node-click="handleNodeClick" :default-checked-keys="defaultCheckedKeys"/>
      </el-card>
      <el-card class="box-card card2" :style="'height:'+scrollbarHeight">
        <!-- 顶部搜索框 -->
        <el-form :inline="true" :model="filters" class="findform">
          <el-form-item label="渠道名称" style="display:flex;width:60%">
            <el-input v-model="filters.EnterpriseName" placeholder="请输入店铺名称·创客手机号" maxlength="20"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="table_container">
          <!--  @selection-change="handleSelectionChange" -->
          <el-table :data="brandList" stripe border>
            <!-- <el-table-column type="selection" align="center" width="55"/> -->
            <el-table-column label="序号" align="center" width="50">
              <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
            </el-table-column>
            <el-table-column label="渠道名称" align="center">
              <template scope="scope">
                <span class="spanList" :title="scope.row.businessname">{{scope.row.businessname}}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人" align="center">
              <template scope="scope">{{scope.row.linkman}}</template>
            </el-table-column>
            <el-table-column label="联系电话" align="center">
              <template scope="scope">{{scope.row.linkphone}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template scope="scope">
                <span @click="seeYaoqing(scope.row, 6)" class="handle"> 邀请 </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="handleTabFive"
          :current-page="pageIndexFive" :page-size="10" :total="totalRowsCountFive" style="margin:10px 0;width: 100%;text-align: right"/>
        </div>
      </el-card>
    </div>
    <div class="button_wrap2" v-if="statusMA==4">
      <el-button @click="statusMA=3">返回</el-button>
      <!-- <el-button type="danger" @click="saveFun">确定邀请</el-button> -->
    </div>
  </div>
  <!-- 被邀渠道 -->
  <div class="main_container" v-show="activeName=='second'">
    <section class="model_section">
      <p class="model_top_title">被邀渠道</p>
    </section>
    <div class="table_container">
      <el-table :data="twoList" @selection-change="handleSelectionChange" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="渠道名称" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.channelname">{{scope.row.channelname}}</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道联系人" align="center">
          <template scope="scope">{{scope.row.linkman}}</template>
        </el-table-column>
        <el-table-column label="联系电话" align="center">
          <template scope="scope">{{scope.row.linkphone}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">{{scope.row.statusname}}</template>
        </el-table-column>
        <el-table-column label="邀请时间" align="center">
          <template scope="scope">{{scope.row.invitetime}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="seeYaoqing(scope.row,7)" class="handle"> 查看邀请 </span>
            <!-- <span @click="invitationFun(scope.row,2)" class="handle" v-if="scope.row.status==1">  <i class="el-icon-circle-check"/> 同意 </span>
            <span @click="invitationFun(scope.row,3)" class="handle" v-if="scope.row.status==1"> <i class="el-icon-circle-close"/> 拒绝 </span> -->
            <!-- <span @click="operationButton(scope.row,3)" class="handle" v-if="scope.row.status==2"> <i class="el-icon-milk-tea"/> 退出 </span> -->
            <span @click="agreeRefuse(scope.row,4)" class="handle" v-if="scope.row.status==2"> <i class="el-icon-milk-tea"/> 退出 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndexTwo" :page-size="10" :total="totalRowsCountTwo" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 重要提示 -->
  <el-dialog :center="true" title="重要提示" :visible.sync="importantIips" width="30%">
    <el-form class="findform">
      {{tipsText}}
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="importantIips = false">取 消</el-button>
      <el-button type="danger" @click="sureTipsFun()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 抽屉详情 右侧抽屉组件 -->
  <el-drawer title="渠道邀请" custom-class="registrationRecord" :visible.sync="channelInvitation" size="35%">
    <div class="drawer-content">
      <!-- <div style="margin-bottom: 10px;color: #F56C6C;" v-show="qdyqWxts==6">温馨提示：根据双方洽谈情况，配置渠道分佣后方可发起渠道邀请。</div>
      <div style="margin-bottom: 10px;color: #F56C6C;" v-show="qdyqWxts==7">温馨提示：根据双方洽谈情况，决定是否接受邀请。</div> -->

      <div v-show="qdyqWxts==5 || qdyqWxts==6">
        <div style="margin-bottom: 10px;color: #F56C6C;">温馨提示：如让利配置有误，可随时取消邀请或移除商家</div>
        <div style="width: 100%;height: 40px;line-height: 40px;text-align: center;background: #E6A23C;color: white;">本店让利</div>
      </div>
      <div v-show="qdyqWxts==7">
        <div style="margin-bottom: 10px;color: #F56C6C;">温馨提示：让利有异议的情况下，可随时退出。</div>
        <div style="width: 100%;height: 40px;line-height: 40px;text-align: center;background: #409EFF;color: white;">渠道商让利</div>
      </div>
      <!-- 品牌建材 & 装修公司 & channeltype==1 -->
      <el-table :data="bdrlList" border>
        <el-table-column property="businessname" :label="channeltype==2?'项目类型':'品牌'" align="center"/>
        <el-table-column property="brokeragetypename" label="让利类型" align="center" v-if="channeltype==1"/>
        <el-table-column prop="channelratetext" label="渠道分佣" align="center">
          <template slot-scope="scope">
            <el-input type="number" v-model="scope.row.channelratetext" v-if="qdyqWxts==6">
              <i slot="suffix" style="margin-right: 10px;font-size: 14px;line-height: 35px;">%</i>
            </el-input>
            <span v-else>{{scope.row.channelratetext}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerratetext" label="客户" align="center">
          <template slot-scope="scope">
            <el-input type="number" v-model="scope.row.customerratetext" v-if="qdyqWxts==6">
              <i slot="suffix" style="margin-right: 10px;font-size: 14px;line-height: 35px;">%</i>
            </el-input>
            <span v-else>{{scope.row.customerratetext}}</span>
          </template>
        </el-table-column>
        <el-table-column property="platformratetext" label="平台" align="center"/>
      </el-table>
      
    </div>
    <div class="drawer-footer">
      <el-button type="info" @click="channelInvitation = false" v-show="qdyqWxts==5 || qdyqWxts==7&&status==2">关闭</el-button>
      <el-button type="info" @click="channelInvitation = false" v-show="qdyqWxts==6">取消</el-button>
      <el-button type="danger" @click="agreeRefuse('',5)" v-show="qdyqWxts==5&&status==1">取消邀请</el-button>
      <el-button type="danger" @click="sureInvite()" v-show="qdyqWxts==6">确定</el-button>
      <el-button type="warning" @click="agreeRefuse('',3)" v-show="qdyqWxts==7&&status==1">拒绝</el-button>
      <el-button type="danger" @click="agreeRefuse('',2)" v-show="qdyqWxts==7&&status==1">同意</el-button>
    </div>
  </el-drawer>
  
  <!-- 请选择店铺 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="handleChangeType">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, } from '../../api/newOss';
import { shopQRCode,cooperationStaffList,delCooperationStaff,merchantAllianceTree,seeMABase,seeMAList,
sourceList,invitationChannel,cancelInvitationChannel,sendInvitationChannelMessage,
removeChannelMerchant,beInvitedChannel,agreeJoinChannel,signOutChannel, sourceInfo, channelInvite, myChannel, channelGetinfo, channelChangestatus } from "../../api/attractInvestment";
export default {
  name: 'merchantChannel',
  mixins: [alertTrends],
  data() {
    return {
      basicInformation: '', //查看联盟基本信息
      tipsState:'',   //当前操作的哪个按钮，点击重要提示的确定按钮时用到
      tipsText:'',  //重要提示内容
      statusMA:3,//1=我的联盟列表,2我的联盟列表点击查看，3管理联盟
      loginForm: {
        mobile: '',
        code: ''
      },
      show: true,
      count: '',
      timer: null,
      importantIips: false,  //控制显示重要提示弹框
      dissolutionPopup: false,
      dialogVisibleadd: false,
      activeName: 'first',
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0, 
      bbid:'',  //店铺id
      bbtype: 1, // 店铺类型 品牌商类型 1=建材商、2=装修公司
      options1: [],
      filters: {
        EnterpriseName: "", // 企业名称
      },
      // 树形控件
      oneData: [],
      defaultCheckedKeys: [],     //树形控件默认选中数组
      defaultProps: {
        label: 'name',
        children: 'node',
      },
      showImageUrl: '',   //店铺码
      staffQRCode: '',  //员工码
      tableListOne: [], //我的联盟列表
      brandList: [],  //我的联盟选择列表
      twoList: [],    //入盟邀请列表
      threeList: [],    //我的员工列表
      tid: '',  //我的联盟店铺合作列表入参记录
      bid: '',  //我的联盟店铺合作列表入参记录
      Brandarr: [],
      brandIndex: [],
      scrollbarHeight: '',
      pageIndex: 1,
      pageIndexTabOne: 1,
      pageIndexTwo:1,   //入盟邀请列表
      totalRowsCountTwo: 0, //入盟邀请总数
      pageIndexThree: 1,    //查看联盟已加入店铺列表分页
      totalRowsCountThree: 0, //查看联盟已加入店铺列表总数
      threeMAList: [],    //查看联盟已加入店铺列表
      pageIndexFour: 1,   //管理联盟-我的联盟列表分页
      totalRowsCountFour: 0, //管理联盟-我的联盟列表总数
      fourMAList: [],     //管理联盟，我的联盟数组
      pageIndexFive: 1,   //管理联盟-邀请商家列表分页
      totalRowsCountFive: 0, //管理联盟-邀请商家列表总数


      groupWorkArr: [],   //被邀联盟选中的数组
      createAllianceAdd: false,   //控制显示创建联盟弹框
      createAllianceForm: {
        allianceNickname:'',
        allianceName: '',
        alliancePhone: '',
        coverImg: '',
      },
      // rules表单验证
      rules: {
        allianceNickname: [
          { required: true, message: '请输入10字以内的联盟名称', trigger: 'blur' }
        ],
        allianceName: [
          { required: true, message: '请输入联盟姓名', trigger: 'blur' }
        ],
        alliancePhone: [
          { required: true, message: '请输入联盟电话', trigger: 'blur' }
        ],
      },
      isdisabled: true,
      goodsImgUrl: "", // 联盟logo
      isCreateMA: '', //1=有自己创建的联盟、0=无自己创建的联盟	
      dismissPhone:'',    //点击解散联盟时用的手机号
      isEdit: false,   //是否是编辑联盟信息

      channelInvitation: false, // 渠道邀请 抽屉组件
      qdyqWxts: '', // 弹框标识
      channeltype: null, // 渠道类型 1品牌建材 & 2装修公司
      bdrlList: [], // 本店让利 & 渠道商让利
    }
  },
  methods: {
    // 点击tab切换
    handleClick(tab, event) {
      this.filters.EnterpriseName = ''; // 清空搜索框
      this.activeName = tab.name;
      this.totalRowsCount = 0;
      if(tab.name=='first'){
        this.statusMA=3;
        this.pageIndexFour = 1;
        this.manageMAList(); // 管理联盟列表
      }
      if(tab.name=='second'){
        this.pageIndexTwo = 1;
        this.invitedShopList(); // 被邀联盟
      }
    },
    /* 管理联盟 */
    // 管理联盟-邀请商家-左侧树
    // 我的联盟tab获取合作品类树
    brandTypeTree(){
      merchantAllianceTree().then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.oneData = data.resultObj;
            this.defaultCheckedKeys.push(data.resultObj[0].id);
            this.tid = data.resultObj[0].id;
            this.bid = [];
            this.pageIndexFive = 1;
            this.cooperationList(data.resultObj[0].id,[]);
          }
        }
      })
    },
    
    // 邀请商家
    inviteMerchants(){
      this.statusMA=4;  //邀请商家
      this.brandTypeTree();
    },
    // 商家渠道列表
    manageMAList(){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        shopId: this.bbid,
        name: this.filters.EnterpriseName, // 关键字
        phone: this.filters.EnterpriseName, // 关键字
        page: this.pageIndexFour,
        size: 10,
      };
      myChannel(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.fourMAList = data.resultObj.list;
            this.totalRowsCountFour = data.resultObj.totalcount;
            // let dataArr = data.resultObj;
            // dataArr.resultObj.forEach(item=>{
            //   item.bbTypeName = item.bbType==1?'品牌建材':'装修公司';
            //   item.stateName = item.state==1?'邀请中':'已加入';
            // })
            // this.fourMAList = dataArr.resultObj;
          } else {
            this.fourMAList = [];
          }
        } else {
            this.fourMAList = [];
        }
      });
    },
    // 被邀渠道
    invitedShopList(){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
        let addParams = {
          shopId: this.bbid,
          page: this.pageIndexTwo,
          size: 10,
        };
        beInvitedChannel(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.twoList = data.resultObj.list;
              this.totalRowsCountTwo = data.resultObj.totalcount;
            } else {
              this.twoList = [];
            }
          } else {
              this.twoList = [];
          }
        });
    },
    // 邀请 / 查看
    seeYaoqing(row,state){
      this.channelInvitation = true;
      this.qdyqWxts = state; // 弹框标识: 5商家渠道 6邀请商家 7被邀渠道
      this.zrrtype = row.channeltype; // 渠道类型 1=品牌建材 2=装修公司 3=自然人创客(用户)
      this.businessid = row.businessid;
      this.channelid = row.channelid;
      this.status = row.status;
      if(this.qdyqWxts==6){
        let obj = {
          shopId: this.bbid, // 当前店铺ID
          channelType: row.channeltype,
          businessId: row.businessid, // 被邀请对象的ID（被邀请店铺ID或被邀请用户ID）
        };
        // 获取可邀请渠道配置详情
        sourceInfo(obj).then(data => {
          if (data.resultCode == 1) {
            this.channeltype = data.resultObj.channeltype; // 邀请店铺类型 1=品牌建材 2=装修公司（可用此字段来判断配置列表中列的显隐）
            this.bdrlList = data.resultObj.configs;
            // this.channelList = data.resultObj.channel;
          }
        })
      }else{
        // 获取已邀请的渠道佣金配置详情
        channelGetinfo('',this.channelid,this.businessid).then(data => {
          if (data.resultCode == 1) {
            let channelid = data.resultObj.channelid; // 渠道ID
            this.status = data.resultObj.status; // 邀请状态 1=邀请中、2=已加入、3=已拒绝、4=已退出
            this.channeltype = data.resultObj.channeltype; // 渠道类型 1=品牌建材 2=装修公司 3=自然人创客(用户)
            this.bdrlList = data.resultObj.configs;
            // this.channelList = data.resultObj.other_details;
          }
        })
      }
    },
    // 确定邀请
    sureInvite(){
      // 非空验证
      if (this.bdrlList.some(item => !item.channelratetext || !item.customerratetext)) {
        this.showAlert('请填写完整的分佣和客户信息');
        return;
      }
      let obj = {
        shopid: this.bbid, // 邀请方店铺ID
        channelshopid: this.zrrtype==1||this.zrrtype==2?this.businessid:0, // 被邀请方店铺ID（邀请店铺时需传值，否则传0）
        channeluserid: this.zrrtype==3?this.businessid:0, // 被邀请方用户ID（邀请用户时需传值，否则传0）
        // configs: this.bdrlList, // 邀请方返佣配置集合
        configs: this.bdrlList.map(item => ({
          businessid: item.businessid,
          brokeragetype: item.brokeragetype,
          shoprate: this.zrrtype == 1 || this.zrrtype == 2 ?item.channelratetext:0, // 店铺的传shop
          userrate: this.zrrtype==3?item.channelratetext:0, // 创客的传us
          customerrate: item.customerratetext
        })),
        
        // channelconfig: this.channelList, // 邀请方返佣配置集合
        // channelconfig: this.channelList.map(item => ({
        //   businessid: item.businessid,
        //   brokeragetype: item.brokeragetype,
        //   shoprate: this.zrrtype == 1 || this.zrrtype == 2 ?item.channelratetext:0, // 店铺的传shop
        //   customerrate: item.customerratetext
        // })),
      };
      channelInvite(obj).then(data => {
        if (data.resultCode == 1) {
          this.channelInvitation = false;
          this.showAlert('操作成功', 'success');
          this.cooperationList(this.tid,this.bid)
          this.manageMAList();
          this.invitedShopList(); // 被邀渠道列表
        }
      })
    },
    // 2同意 & 3拒绝 & 4取消邀请 & 4移除渠道
    agreeRefuse(row, type){
      let obj = {
        channelid: row?row.channelid:this.channelid, // 渠道ID
        businessid: this.businessid?this.businessid:row.businessid, // 渠道对象ID（被邀请店铺ID或被邀请用户ID）
        status: type, // 操作状态 2=已加入、3=已拒绝、4=已退出
      };
      channelChangestatus(obj).then(data => {
        if (data.resultCode == 1) {
          this.channelInvitation = false;
          this.showAlert('操作成功', 'success');
          this.manageMAList(); // 商家渠道列表
          this.invitedShopList(); // 被邀渠道列表
        }
      })
    },
    // 移除商家/取消联盟邀请/发送联盟邀请通知
    fourMATipsFun(row,state){
      let addParams = {
        bbId: this.bbid, // 发出邀请店铺id	
        invitationBbId: row.businessid, // 受邀店铺id

      };
      let thisApi = state==1?cancelInvitationChannel:state==2?sendInvitationChannelMessage:removeChannelMerchant;
      thisApi(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.showAlert('操作成功', 'success');
            this.manageMAList();
          }
        }
      })
    },
    /*入盟邀请 */
    // 入盟邀请-同意或拒绝
    invitationFun(row,state){
      // state==2同意入盟，3拒绝入盟
      let addParams = {
        bbId: row.id, // 发出邀请店铺id
        inBbId: this.bbid,   //受邀店铺id
        state: state
      };
      agreeJoinChannel(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.showAlert('操作成功', 'success');
            this.invitedShopList();
          }
        }
      })
    },
    //查看联盟已加入店铺列表
    seeMAListFun(row){
      let addParams = {
        key: this.filters.EnterpriseName, // 关键字
        maId: this.maId,
        pageIndex: this.pageIndexThree,
        pageSize: 10
      };
      seeMAList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            data.resultObj.resultObj.forEach(item=>{
              item.bbTypeName = item.bbType==1?'品牌建材':'装修公司';
            })
            this.threeMAList = data.resultObj;
            this.totalRowsCountThree = data.resultObj.rowsCount;
          } else {
            this.threeMAList = [];
          }
        } else {
            this.threeMAList = [];
        }
      })
    },
    //查看联盟基本信息
    seeMABaseFun(row){
      let addParams = {
        maId: this.maId,
      };
      seeMABase(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.basicInformation = data.resultObj;     //基本信息
          }
        }
      })
    },
    
    // 点击联盟列表操作按钮
    operationButton(row,state){
      // state=1:取消申请，2设为主推，3退出，4查看，5管理联盟
      this.tipsState = state;   //当前操作的是哪个按钮
      this.maId = row.id;
      if(state==1){   //取消申请
        this.importantIips = true;
        this.tipsText = `您确定要取消创建${row.name}联盟的申请吗？`;
      } else if(state==2){   //设为主推
        this.importantIips = true;
        this.tipsText = `您确定将${row.name}联盟设置为主推联盟吗？`;
      } else if(state==3){   //退出
        this.importantIips = true;
        this.tipsText = `您确定将您的店铺从${row.name}渠道中退出吗？`;
      } else if(state==4){      //查看
        this.statusMA=2;   //查看联盟
        this.seeMAListFun(row);  //查看联盟已加入店铺列表
        this.seeMABaseFun(row);  //查看联盟基本信息
      } else if(state==5){     //管理联盟
        this.statusMA=3;   //管理联盟
        this.dismissPhone = row.contactsPhone;   //点击解散联盟时用的手机号
        this.manageMAList();    //管理联盟列表
        this.seeMABaseFun(row);  //查看联盟基本信息
      }
    },
    
    // 点击重要提示-确定按钮
    sureTipsFun(){
      // 3退出
      if(this.tipsState==3){
        let addParams = {
          bbId: this.maId, // 发出邀请店铺id
          inBbId: this.bbid,   //受邀店铺id
        };
        signOutChannel(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.showAlert('操作成功', 'success');
              this.importantIips = false;
              this.invitedShopList();
            }
          }
        })
      }
    },
    // 选择品类树列表
    handleNodeClick(data,d1,d2) {
      this.cooperationList(data.id,d1.id);
      // if(data.id==-1||data.id==-2){
      //   this.tid = data.id;
      //   this.bid = 0;
      //   this.cooperationList(data.id,0);
      // } else {
      //   this.filters.EnterpriseName = '';     //清空搜索框
      //   if(d1.level==2){
      //     this.tid = data.id;
      //     this.bid = '';
      //   } else if (d1.level==3){
      //     this.bid = data.id;
          
      //     if(this.tid!=''&&this.bid!=''){
      //       this.cooperationList(this.tid,this.bid);
      //       this.Brandarr = [];
      //     }
      //   }
      // }
    },

    // 管理联盟-邀请商家-获取未邀请的店铺列表
    cooperationList(tid,bid){
      let addParams = {
        shopId: this.bbid,
        typeId: tid, // 0=全部渠道 -1创客渠道 -2=装修公司 >0店铺品类ID  old  （品类树一级id）类型 -1=全部 -2=装修公司   其他为品类id
        brandId: tid>0?bid:0,  // 品牌ID（ typeid>0时传入）  old  （品类树三级id）品牌id
        name: this.filters.EnterpriseName,
        phone: this.filters.EnterpriseName,
        page: this.pageIndexFive,
        size: 10,
      };
      sourceList(addParams).then(data => {
        if (data.resultCode == 1) {
          this.brandList = data.resultObj.list;
          this.totalRowsCountFive = data.resultObj.totalcount;
          this.Brandarr = [];
          this.brandList.forEach(element => {
            if(element.isSelect == 1){
              this.Brandarr.push(element.id)
            }
          });
        }else{
          this.brandList = [];
          this.totalRowsCountFive = 0;
        }
      })
    },

    // 点击品牌品类
    choosedBrand(item, index) {
      if (this.Brandarr.indexOf(item.id) > -1) {
        this.Brandarr.splice(this.Brandarr.indexOf(item.id), 1);
        this.$set(item, "isSelect", 0);
      } else {
        this.Brandarr.push(item.id);
        this.$set(item, "isSelect", 1);
      }
    },

    // 点击全选
    choosedAllBrand(item){
      this.Brandarr = [];
      this.brandIndex = [];
      this.brandList.forEach(element => {
        element.isSelect = 1;
        this.Brandarr.push(element.id)
      });
    },

    // 点击确定邀请按钮
    saveFun(){
      if(this.groupWorkArr.length>0){
        let addParams = {
          bbid: this.bbid,
          invitationBbIds: this.groupWorkArr
        };
        invitationChannel(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.showAlert('邀请成功', 'success');
              this.statusMA=3;
              this.cooperationList(this.tid,this.bid)
              this.manageMAList();
            }
          }
        })
      } else {
        this.showAlert('请先勾选列表');
      }
    },
    
    // 被邀联盟复选框
    handleSelectionChange(val) {
      this.groupWorkArr = [];
      val.forEach(element => {
        this.groupWorkArr.push(element.id);
      });
    },

    // 我的员工列表
    cooperationStaffList(){
      let addParams = {
        bbid: this.bbid,
        key: this.filters.EnterpriseName,
        pageIndex: this.pageIndexTabOne,
        pageSize: 10,
      };
      cooperationStaffList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.threeList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.threeList = []
          }
        } else {
            this.threeList = []
          }
      })
    },

    // 删除员工
    deleteFun(row){
      let addParams = {
        bbid: this.bbid,
        staffUserId: row.id
      };
      delCooperationStaff(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.showAlert('操作成功', 'success');
            this.cooperationStaffList();
          } else {
            this.showAlert(data.resultMsg);
          }
        }
      })
    },

    /**
     * 根据图片路径下载图片
     * @param imgsrc 图片地址
     * @param name 保存的图片名
     */
    downloadImage(imgSrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题,
      image.setAttribute("crossorigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 将图片格式转为base64
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "myPhoto"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgSrc + '?time=' + Date.now();  // 注意，这里是灵魂，否则依旧会产生跨域问题
    },
    // 下载店铺码
    xiazai() {
      let address = this.showImageUrl;
      let intercept = this.showImageUrl.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },
    // 下载员工二维码
    xiazaiYg() {
      let address = this.staffQRCode;
      let intercept = this.staffQRCode.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },

    // 获取店铺码
    shopQRCode(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
        bbid: this.bbid
      };
      shopQRCode(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.showImageUrl = data.resultObj.qrCode;        //店铺
            this.staffQRCode = data.resultObj.staffQRCode;    //员工
          }
        }
      })
    },


    //查询
    onSubmit() {
      if(this.activeName=='first'){
        if(this.statusMA==3){ // 我的联盟--管理联盟--列表
          this.pageIndexFour = 1;
          this.manageMAList();
        } else if(this.statusMA==4){ // 我的联盟--管理联盟--邀请商家
          this.pageIndexFive = 1;
          this.cooperationList(this.tid,this.bid)
        }
      } else if(this.activeName=='second'){
        this.pageIndexTwo = 1;
        this.invitedShopList(); // 被邀联盟
      }

      this.pageIndex = 1;
      // this.getInit();
    },
    // 入盟邀请分页
    handleCurrentChange(val) {
      this.pageIndexTwo = val;
      this.invitedShopList();
    },
    // 查看联盟已加入的店铺列表 分页
    handleTabThree(val) {
      this.pageIndexThree = val;
      this.seeMAListFun();
    },
    // 我的员工 分页
    handleTabOne(val) {
      this.pageIndexTabOne = val;
      this.cooperationStaffList();
    },
    // 我的联盟-管理联盟列表 分页
    handleTabFour(val) {
      this.pageIndexFour = val;
      this.manageMAList();
    },
    // 我的联盟-管理联盟-邀请商家列表 分页
    handleTabFive(val) {
      this.pageIndexFive = val;
      this.cooperationList(this.tid,this.bid)
    },

    //商家联盟获取用户身份以及可查看的店铺
    initshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data.resultCode == 1) {
          if(data.resultObj.length>1){
            // this.bbid = data.resultObj[0].id; // 店铺id
            // this.gonext();
            this.dialogVisibleadd = true;
            this.options1 = data.resultObj;
          } else { // 默认选中第一个店铺不显示弹框
            this.dialogVisibleadd = false;
            this.bbid = data.resultObj[0].id; // 店铺id
            this.bbtype = data.resultObj[0].shopType; // 店铺类型
            this.gonext();
          }
        }else{
          this.showAlert('请先在店铺信息功能中创建自己店铺');
          return false;
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.manageMAList();
      this.dialogVisibleadd = false;
      this.shopQRCode(); // 店铺推广码
    },
    // 获取店铺类型
    handleChangeType(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.bbtype = item.shopType; // 获取店铺类型
        }
      })
    },
  },
  created() {
    this.initshop(); //商家联盟获取用户身份以及可查看的店铺
    // this.brandTypeTree(); //我的联盟tab获取合作品类树
    // this.shopQRCode();    //店铺推广码
  },
  mounted() {
    this.scrollbarHeight = document.documentElement.clientHeight * 0.7 + "px"
    window.onresize = () => {
      if (this.scrollbarHeight) this.scrollbarHeight = document.documentElement.clientHeight * 0.7 + "px"
    };
  },
  watch: {
    'defaultCheckedKeys':function(newVal, oldVal) {
      if(newVal){
        this.$nextTick(() => {
          document.querySelector('.el-tree-node__content').click()
        })
      }
    }
  },

}
</script>
<style>
.el-form .el-form-item__label {
  width: 80px;
}
</style>
<style scoped>
.spanflex {
  display: flex;
  justify-content: space-around;
}

/* 按钮位置 */
.button_wrap{
  margin: 0 20px 10px;
  display: flex;
  justify-content: flex-end;
}

/* 温馨提示 */
.reminder{
  margin: 0 20px 10px;
  font-size: 14px;
}

/* 我的联盟样式 */
.displayFlex{
  display: flex;
  justify-content: flex-start;
}
.card1{
  width: 20%;
  overflow-y: auto;
}
.card2{
  width: 80%;
  overflow-y: auto;
  position: relative;
}

.button_wrap1{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  margin: 0 auto;
  margin-left: calc(50% - 33px);
}
.button_wrap2{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 40px;
  background: #fff;
  margin: 10px auto;
  margin-left: calc(50% - 33px);
}

/* .button_wrap1 button{
  margin: 0 auto;
} */


/* 店铺码 */
.QRCodeClass {
  width: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
.dianpuma {
  width: 180px;
  text-align: center;
  margin-bottom: 20px;
}
.dianpuma_tit{
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
}
/* 二维码 */
.erweima {
  width: 150px;
  height: 211px;
  margin-bottom: 10px;
}

.searchBot {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.searchBot p {
  width: 42%;
  display: inline-block;
  padding: 8px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  text-align: center;
}

.style1{
  color: #606266;
  background: #f0f0f0;
}

.style2{
  color: #fff;
  background: #F56C6C !important;
}

.btn_operation{
  color: #F56C6C;
  cursor: pointer;
}

.bold{
  font-weight: bold;
}
.faceUrl{
  width: 40px; 
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

/* 验证码样式 */
.pr {
   position: relative;
}
.code-btn {
   width: 100px;
   height: 36px;
   position: absolute;
   top: 3px;
   right: 5px;
   z-index: 222;
   color: #F5A623;
   font-size: 14px;
   border: none;
   border-left: 1px solid #e5e5e5;
   padding-left: 16px;
   background-color: #fff;
}

.red{
  color: #f00!important;
}
.return{
  position: absolute;
  bottom: 10px;
  /* left: calc(50% - 40px); */
  left: 20px;
}
.handle{
  padding: 0 5px;
}
/* 查看-抽屉 */
.registrationRecord {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.drawer-content {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 60px;
}
.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  background: #fff;
  border-top: 1px solid #ebeef5;
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// merchantChannel.vue?0fd9697f